var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"collapse-trigger",class:{
      'content-expended': !_vm.collapsed,
    },on:{"click":_vm.toggle}},[_vm._t("trigger")],2),_c('div',{ref:"contentWrapperRef",staticClass:"collapse-content"},[_c('div',{ref:"contentRef"},[_vm._t("content")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }